// @ts-nocheck

import React, { useState } from 'react';
import apiFetch, { defaultApiFetchErrorHandler } from '@scale/frontend-lib/api-fetch';
import useDebouncedValue from 'react-scale/hooks/useDebouncedValue';
import Autocomplete from '../../components/SimpleAutocomplete';
import HTTPError from '@scale/frontend-lib/httpError';
import { AutocompleteOption } from 'design-system/Autocomplete/Autocomplete';
import { useQuery } from 'react-query';

const queryKey = 'fetch-workerteams'; // Arbitrary token to disambiguate lookups to useQuery.
async function searchWorkerTeams(
  text: string | undefined,
  pinnedIds?: string[],
): Promise<AutocompleteOption[]> {
  try {
    const pinnedIdsStr = pinnedIds?.join(',');
    return await apiFetch(null, `corp-api/worker_teams/autocomplete`, {
      query: {
        search: text,
        pinnedIds: pinnedIdsStr,
      },
    }).then(
      ({ results }) =>
        results.map(({ id, name }: { id: string; name: string }) => ({
          id,
          title: name,
        })) as AutocompleteOption[],
    );
  } catch (error) {
    defaultApiFetchErrorHandler(error as HTTPError, { handleHttp: true });
    return [];
  }
}
const WorkerTeamAutocomplete: React.FC<{
  selectedWorkerTeam: { id: string; title: string };
  setSelectedWorkerTeam: (value: { id: string; title: string }) => void;
  disabled?: boolean;
}> = ({ selectedWorkerTeam, setSelectedWorkerTeam, disabled }) => {
  const [inputValue, setInputValue] = useState<string>('');
  const debouncedInputValue = useDebouncedValue(inputValue, 200);
  const queryResults = useQuery<AutocompleteOption[], Error>([queryKey, debouncedInputValue], () =>
    searchWorkerTeams(debouncedInputValue),
  );
  const options = queryResults.data ?? [];

  return (
    <>
      <Autocomplete
        id="workerteam-autocomplete"
        className="w-full"
        options={options}
        value={{
          ...selectedWorkerTeam,
          title: selectedWorkerTeam.title.length
            ? selectedWorkerTeam.title
            : options.find(option => option.id === selectedWorkerTeam.id)?.title ?? '',
        }}
        setSelectedOption={setSelectedWorkerTeam}
        onInputChange={setInputValue}
        disabled={disabled}
        loading={queryResults.status === 'loading'}
        placeholder="Search WTs by name..."
      />
    </>
  );
};

export default WorkerTeamAutocomplete;
